
import Vue from "vue";
import { Carousel, Slide } from "vue-carousel";
import MovieContainer from "./MovieContainer.vue";

export default Vue.extend({
  name: "MultiMovies",
  props: {
    urls: Array,
  },
  components: {
    Carousel,
    Slide,
    MovieContainer,
  },
  methods: {
    youtubeUrl(url: string): string {
      if (!url) {
        return null;
      }
      const key = url.split("/").pop()?.replace("?t=", "?start=");
      return `https://www.youtube.com/embed/${key}`;
    },
  },
  computed: {
  },
});
